import React from "react"
import { Skills } from "../components/skills"




export const SkillsPage: React.FC = () =>{
  return (
    <div className="page">
      <Skills/>
    </div>

    )
}